import * as React from 'react';
import * as moment from 'moment';

import { GridMonthProps } from '../../components/grid/month';
import GridDay from '../../components/grid/day';

const GridMonthView: React.StatelessComponent<GridMonthProps> = props => {
    const hasEvents = props.monthData.events.allDays.length > 0;
    const daysOfTheWeek = moment.weekdays(true);

    if (hasEvents) {
        return (
            <li className="ace-cal-grid-month">
                <section>
                    <h2 tabIndex={-1} className="ace-cal-grid-month-name uppercase" id={`Month-${props.monthData.monthMoment.format("X")}`}>{props.monthData.monthMoment.format("MMMM YYYY")}</h2>
                    {
                        props.showDaysOfWeek ?
                            <ul className="ace-cal-grid-weekdays" aria-hidden="true">
                                {
                                    daysOfTheWeek.map(day => <li className="ace-cal-grid-weekday h4-style uppercase" key={day}>{day}</li>)
                                }
                            </ul>
                            : null
                    }
                    <ul className="ace-cal-grid-days" aria-labelledby={`Month-${props.monthData.monthMoment.format("X")}`}>
                        {
                            props.monthData.events.days.map(day => props.monthData.monthMoment.month() === day.date.getMonth() ?
                                <GridDay key={day.date.toDateString()} day={day} isToday={moment(day.date).isSame(props.todaysDate, 'day')} /> :
                                <li key={day.date.toDateString()} className="ace-cal-grid-day-empty" aria-hidden="true"><span aria-hidden="true" role="presentation" className="ace-cal-grid-day-date light">{day.date.getDate()}</span></li>)
                        }
                    </ul>
                </section>
            </li>
        );
    } else {
        return (
            <li className="ace-cal-grid-month">
                <section>
                    <h2 tabIndex={-1} className="ace-cal-grid-month-name uppercase" id={`Month-${props.monthData.monthMoment.format("X")}`}>{props.monthData.monthMoment.format("MMMM YYYY")}</h2>
                    <div className="ace-cal-grid-days-empty" dangerouslySetInnerHTML={{ __html: props.text.emptyMonthMessaging }} aria-labelledby={`Month-${props.monthData.monthMoment.format("X")}`}></div>
                </section>
            </li>
        )
    }
}

export default GridMonthView;